<script setup>
import { useApi } from '@/utils/api'

// Module 16 (§9.3) — "reuse ChecklistFillForm.vue" (blueprint §Module16 Vue
// Page), difilter ke 3 kategori MFK (APAR/Kebersihan/Genset, sudah diseed
// sejak Module 05/16). Satu halaman: pilih template MFK -> isi lewat
// ChecklistFillForm.vue dengan prop `mfk` (submit ke route MFK sendiri
// supaya auto-Task FacilityMonitoringService ikut terpicu, lihat komponen
// itu & CLAUDE.md § MFK Module).
definePage({
  meta: {
    layout: 'default',
    action: 'checklist-fill',
    subject: 'Mfk',
  },
})

const MFK_CATEGORY_CODES = ['APAR', 'KEBERSIHAN', 'GENSET']

const templates = ref([])
const loading = ref(false)
const selectedTemplateId = ref(null)

const load = async () => {
  loading.value = true
  try {
    const categoriesResponse = await useApi('/api/v1/master-data/checklist-categories', { query: { per_page: 100 } }).get()
    const categories = (categoriesResponse?.data ?? categoriesResponse?.data?.data ?? []).filter(c => MFK_CATEGORY_CODES.includes(c.code))
    const categoryIds = categories.map(c => c.id)

    const templatesResponse = await useApi('/api/v1/checklist-templates', { query: { per_page: 100 } }).get()
    const allTemplates = templatesResponse?.data ?? templatesResponse?.data?.data ?? []

    templates.value = allTemplates.filter(t => categoryIds.includes(t.category?.id))
  } finally {
    loading.value = false
  }
}

onMounted(load)

const templateOptions = computed(() => templates.value.map(t => ({ title: `${t.name} (${t.category?.name ?? '-'})`, value: t.id })))
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Checklist MFK
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Checklist APAR, kebersihan, dan genset (§9.3)
    </p>

    <VCard class="mb-4">
      <VCardText>
        <VSelect
          v-model="selectedTemplateId"
          :items="templateOptions"
          :loading="loading"
          label="Pilih Checklist"
          clearable
        />
      </VCardText>
    </VCard>

    <ChecklistFillForm
      v-if="selectedTemplateId"
      :key="selectedTemplateId"
      :template-id="selectedTemplateId"
      mfk
    />
  </div>
</template>
